import React from 'react'
import i18n from 'i18n'
import type { TFunction } from 'i18next'
import { commonMenuList } from 'apptype-config'

export interface MenuItem {
  divider?: boolean
  title?: string
  key?: string
  url?: string
  icon?: string | React.ComponentType
  children?: MenuItem[]
  disabled?: boolean
  count?: number
  roles?: string[]
  target?: string
  category?: boolean
}

export interface MenuListResult {
  adminMenuList: MenuItem[]
  menuList: MenuItem[]
}

export function getAdminMenuList(): MenuItem[] {
  const menuList: MenuItem[] = []

  return menuList
}

export default function getMenuList(): MenuListResult {
  const t = (i18n as any).t as TFunction
  const adminMenuList: MenuItem[] = [
    {
      title: t('menu.user.myRecords'),
      key: 'myRecords',
      url: '/records/mine',
    },
  ]

  const menuList = commonMenuList(i18n)

  return {
    adminMenuList,
    menuList,
  }
}
